import { useTranslation } from 'react-i18next';
import Title from '../Title.jsx';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  const sections =
    t('policy.privacy_policy.sections', { returnObjects: true }) || [];

  const contactLabels = [
    'Contact Details',
    'Coordonnées',
    'Datos de contacto',
    'Contatti',
  ];

  const isContact = (heading) =>
    contactLabels.some((label) => heading?.includes(label));

  const renderSectionTree = (section, index) => {
    if (!section) return null;

    return (
      <div key={section.id || index} className='text-primary-blue text-justify'>
        {section.heading && (
          <p className='py-2 text-lg lg:text-xl font-medium'>
            {section.heading}
          </p>
        )}

        {section.paragraphs?.map((para, paraIndex) => (
          <p
            key={paraIndex}
            className='text-lg lg:text-xl font-light'
            dangerouslySetInnerHTML={{ __html: para }}
          />
        ))}

        {section.items && (
          <ul className='list-disc'>
            {section.items.map((item, itemIndex) => (
              <li key={itemIndex} className='text-lg lg:text-xl font-light'>
                {item}
              </li>
            ))}
          </ul>
        )}

        {section.subSections?.map((subSection, subIndex) =>
          renderSectionTree(subSection, subIndex)
        )}
      </div>
    );
  };

  return (
    <div className='flex flex-col p-6 md:p-12 gap-6 md:gap-12 text-center max-w-[1600px] mx-auto w-full break-words'>
      <Title>{t('policy.privacy_policy.title')}</Title>
      <p className='text-lg lg:text-xl font-light text-gray-500'>
        {t('policy.privacy_policy.policy_subtitle')}
        <span className='font-medium text-primary-red'>Quantessence</span>{' '}
        {t('policy.privacy_policy.policy_common')}{' '}
        {t('policy.privacy_policy.policy_date')}
      </p>
      {sections.map((section, index) => {
        const contactSection = isContact(section.heading);
        return (
          <div
            key={section.id || index}
            className='text-primary-blue text-justify'
          >
            <p className='text-xl lg:text-2xl font-medium'>{section.heading}</p>
            {section.paragraphs?.map((paragraph, paraIndex) => (
              <p
                key={paraIndex}
                className='text-lg lg:text-xl font-light'
                dangerouslySetInnerHTML={{ __html: paragraph }}
              />
            ))}
            {contactSection && section.contacts?.length >= 2 && (
              <div className='grid grid-cols-1 lg:grid-cols-2 py-4 text-lg lg:text-xl font-light'>
                {section.contacts.map((contact, idx) => (
                  <div key={idx} className='border rounded'>
                    <div className='p-2 text-lg lg:text-xl font-medium text-white bg-primary-red'>
                      {contact.branch}
                    </div>
                    <div className='p-2'>
                      {contact.entity}
                      <br />
                      <span className='font-medium'>{contact.officer}</span>
                      <br />
                      <br />
                      {contact.address}
                      <br />
                      <br />
                      email: {contact.email}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {!contactSection &&
              section.subSections?.map((subSection, subIndex) =>
                renderSectionTree(subSection, subIndex)
              )}
          </div>
        );
      })}
    </div>
  );
};

export default PrivacyPolicy;
